<template lang="pug">
div.body-lo
  div.modal-header
    span.lo-modal-title ĐĂNG XUẤT
    span.lo-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body
    div.reg-content Bạn có chắc muốn đăng xuất khỏi tài khoản này không?
  div.modal-footer.lo-custom-footer
    div.row
      div.col-md-6.col-12
        div.text-right
          a.lo-btn-continue.btn(@click='validateLogout()') Xác nhận
      div.col-md-6.col-12
        div.text-left
          a.lo-btn-back.btn(@click="$emit('close')") Hủy
</template>
<script>
import store from '../../store'
export default {
  methods: {
    validateLogout() {
      // console.log('Logout')
      this.$store.dispatch('signOutAction').then((status, msg) => {
        this.$emit('close')
        store.commit('setIsLoggedIn', false)
        store.commit('setUser', null)
        store.commit('setFullname', null)
        this.$router.push('/home')
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-lo {
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .lo-modal-title {
    font-family: 'adobe-clean', sans-serif;
    float: left;
    font-size: 17px;
  }
  .lo-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .lo-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .lo-btn-continue {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .lo-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .lo-custom-footer {
    padding: 0;
    border: 0;
  }
@media (max-width: 991px) {
  .lo-custom-footer{text-align: center;
    .col-12{display: inline-block;
      .lo-btn-continue{float: none; margin-bottom:15px; margin-left: 0;}
      .lo-btn-back{float: none;  margin-bottom:15px; margin-right: 0;}
    }
  }
}
// cellphones 
@media (max-width: 414px) {
  .lo-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
  }
  .lo-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
  }
}
}
</style>



// WEBPACK FOOTER //
// Logout.vue?aa486b58